import { isNil, map, merge, filter, isEmpty, length } from "ramda";
import visitField from "./valueToContentFieldVisitor";
import { typeName } from "application/constants/app-constants";
import generateRandomId from "application/functions/generateRandomId";

const getObjectForGroup = (obj) => ({
  path: obj.path,
  translatable: obj.translatable,
  contentFields: [],
  value: null,
  mediaInfo: null,
  inputType: "GROUP",
  cssList: null,
});

const internalLoping = (value, structure, fn) => map((node) => fn(node, value), structure);

const exists = (obj) => !isNil(obj) && !isEmpty(obj);

const clean = (list) => {
  const newList = filter((obj) => exists(obj) && hasValue(obj), list);
  return map((cf) => {
    if (cf?.inputType === "GROUP") {
      const newGroup = map((cfg) => clean(cfg), cf.contentFields ?? []);
      cf.contentFields = newGroup;
      return cf;
    }
    return cf;
  }, newList);
};
//const clean = list => filter(obj => exists(obj) && hasValue(obj), list);

const hasValue = (field) => {
  if (field.inputType === "GROUP") {
    return hasGroupValue(field);
  }
  if (field.inputType === "SELECT") {
    return hasSelectValue(field);
  }
  if (field.inputType === "MEDIA") {
    return hasMediaValue(field);
  }
  if (field.inputType === "MAP") {
    return hasMapValue(field);
  }
  return hasNormalValue(field);
};

const hasNormalValue = (field) => {
  const value = filter((v) => exists(v), field?.value ?? []);
  return length(value) > 0;
};

const hasMediaValue = (field) => {
  const value = filter((v) => exists(v), field?.value ?? []);
  const mediaInfo = filter((m) => exists(m), field?.mediaInfo ?? []);
  return length(value) > 0 || length(mediaInfo) > 0;
};

const hasSelectValue = (field) => {
  const selectedOptions = filter((v) => exists(v), field?.selectedOptions ?? []);
  return length(selectedOptions) > 0;
};

const hasMapValue = (field) => {
  const mapValues = filter((v) => exists(v), field?.map ?? []);
  return length(mapValues) > 0;
};

const hasGroupValue = (field) => {
  const contentFields = filter((cf) => exists(cf), field?.contentFields ?? []);
  const cleanedContentFields = map((cf) => clean(cf), contentFields ?? []);
  return length(cleanedContentFields) > 0;
};

const getValueControlId = (value) => {
  if (isNil(value?.controlId)) {
    return generateRandomId();
  }
  return value.controlId;
};

const getValueRepeatableControlId = (value, path) => map((obj) => getValueControlId(obj[path]), value);

const visiteNode = (node, value) => {
  if (isNil(value)) {
    return null;
  }
  if (node[typeName] === "StructureFieldGroup") {
    if (isNil(value[node.path]) === false) {
      if (node.repeatable === true) {
        const path = node.path;
        const varValueMapeados = map((obj) => internalLoping(obj[path], node.structureFields, visiteNode), value[path]);
        return merge(getObjectForGroup(node), {
          contentFields: varValueMapeados,
          controlId: getValueRepeatableControlId(value[path], path),
        });
      }
      const valuesMapeados = internalLoping(value[node.path], node.structureFields, visiteNode);
      return merge(getObjectForGroup(node), {
        contentFields: [valuesMapeados],
        controlId: getValueControlId(value[node.path]),
      });
    }
    return null;
  }
  if (node[typeName] === "StructureFieldSelector") {
    return visitField(merge(node, { type: "SELECT" }), value);
  }
  if (isNil(value[node.path]) === false && value[node.path] !== "") {
    return visitField(node, value);
  }
  return null;
};

const valueToContentAdapter = (value, structure) => clean(internalLoping(value, structure, visiteNode));

export default valueToContentAdapter;
